import { styled } from '@mui/material';

export const PreviousPrice = styled('span')({
  textDecoration: 'line-through',
});
